import { call, put } from '@redux-saga/core/effects';
import { api, apiErrorHandler, notify } from 'services';
import {
  UpdateAreaActions as Actions,
  UpdateAreaRequestAction as RequestAction,
} from 'store/ducks/areas';

export function* updateAreaRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `areas/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Área atualizada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
